var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSend1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 87,
    viewBox: "0 0 81 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON SEND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1611 31.5331L76.4412 16.4772L51.0478 70.001L38.7477 47.3966L20.1611 31.5331Z",
    stroke: "#EF7056",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.4424 16.4773L38.7489 47.3967",
    stroke: "#EF7056",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.334 40.8032L28.9975 51.8403C28.6857 54.4034 30.5099 56.7334 33.0706 57.0535L44.4649 58.4777",
    stroke: "#EF7056",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.705 46.5507L5.47453 51.4478",
    stroke: "#EF7056",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.1711 61.3665L5.22058 71.5189",
    stroke: "#EF7056",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.9388 67.5854L28.5965 76.4751",
    stroke: "#EF7056",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend1);
export default __webpack_public_path__ + "static/media/icon-send-1.39bb80f820b7fc67e17d14426673c7fe.svg";
export { ForwardRef as ReactComponent };